import axios from 'axios';
import { Dispatch } from 'react';
import { AnyIfEmpty } from 'react-redux';
import {
    GET_LOCATION_FAILURE,
    GET_LOCATION_REQUEST,
    GET_LOCATION_SUCCESS,
    GET_LOCATION_BY_ID_FAILURE,
    GET_LOCATION_BY_ID_REQUEST,
    GET_LOCATION_BY_ID_SUCCESS,
    CLEAR_PREVIOUS_LOCATION_DATA,
    LOCATION_CLICK_EVENT_REQUEST,
    LOCATION_CLICK_EVENT_FAILURE,
    LOCATION_CLICK_EVENT_SUCCESS,
    GET_STATE_LOCATION_SUCCESS,
    GET_STATE_LOCATION_FAILURE,
    GET_STATE_LOCATION_REQUEST,
    GET_LOCATION_DETAILS_BY_ID_FAILURE,
    GET_LOCATION_DETAILS_BY_ID_SUCCESS,
    GET_LOCATION_DETAILS_BY_ID_REQUEST,
    GET_LOCATION_FILTERS_REQUEST,
    GET_LOCATION_FILTERS_SUCCESS,
    GET_LOCATION_FILTERS_FAILURE,
    RESET_LOCATION_FILTERS,
} from '../constants/location.constant';
import { stat } from 'fs';

// Get Location Request
const getLocationRequest = () => {
    return {
        type: GET_LOCATION_REQUEST,
    };
};

const getLocationSuccess = (locations: AnyIfEmpty<object>) => {
    return {
        type: GET_LOCATION_SUCCESS,
        payload: locations,
    };
};

const getLocationFailure = (locationError: AnyIfEmpty<object>) => {
    return {
        type: GET_LOCATION_FAILURE,
        payload: locationError,
    };
};

const getLocationByIdRequest = () => {
    return {
        type: GET_LOCATION_BY_ID_REQUEST,
    };
};

const getTimeZoneLocationSuccess = (locations: AnyIfEmpty<object>) => {
    return {
        type: GET_STATE_LOCATION_SUCCESS,
        payload: locations,
    };
};

const getTimeZoneLocationFailure = (locationError: AnyIfEmpty<object>) => {
    return {
        type: GET_STATE_LOCATION_FAILURE,
        payload: locationError,
    };
};

const getTimeZoneLocationRequest = () => {
    return {
        type: GET_STATE_LOCATION_REQUEST,
    };
};

const getLocationByIdSuccess = (locationByIdData: AnyIfEmpty<object>) => {
    return {
        type: GET_LOCATION_BY_ID_SUCCESS,
        payload: locationByIdData,
    };
};

const getLocationByIdFailure = (locationByIdError: string) => {
    return {
        type: GET_LOCATION_BY_ID_FAILURE,
        payload: locationByIdError,
    };
};

const clearPreviousLocationData = () => {
    return {
        type: CLEAR_PREVIOUS_LOCATION_DATA,
    };
};

export const clearPreviousLocation = () => {
    return (dispatch: Dispatch<any>) => {
        dispatch(clearPreviousLocationData());
    };
};

const getLocationDetailsByIdSuccess = (locationByIdData: AnyIfEmpty<object>) => {
    return {
        type: GET_LOCATION_DETAILS_BY_ID_SUCCESS,
        payload: locationByIdData,
    };
};

const getLocationDetailsByIdFailure = (locationByIdError: string | AnyIfEmpty<object>) => {
    return {
        type: GET_LOCATION_DETAILS_BY_ID_FAILURE,
        payload: locationByIdError,
    };
};

const getLocationDetailsByIdRequest = () => {
    return {
        type: GET_LOCATION_DETAILS_BY_ID_REQUEST,
    };
};

// Get Location Dispatch
export const getLocation = () => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getLocationRequest());
        return await axios
            .get(`/locations`)
            .then((response) => dispatch(getLocationSuccess(response.data.locations)))
            .catch((error) => dispatch(getLocationFailure(error)));
    };
};

export const getLocationbySelectedStates = (states: string[]) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getTimeZoneLocationRequest());
        return await axios
            .get(`/locations`, {
                params: {
                    states: JSON.stringify(states),
                },
            })
            .then((response) => {
                dispatch(getTimeZoneLocationSuccess(response.data.locations));
            })
            .catch((error) => dispatch(getTimeZoneLocationFailure(error)));
    };
};

const locationClickEventRequest = () => {
    return {
        type: LOCATION_CLICK_EVENT_REQUEST,
    };
};

const locationClickEventSuccess = (locationByIdData: AnyIfEmpty<object>) => {
    return {
        type: LOCATION_CLICK_EVENT_SUCCESS,
        payload: locationByIdData,
    };
};

const locationClickEventFailure = (locationByIdError: string) => {
    return {
        type: LOCATION_CLICK_EVENT_FAILURE,
        payload: locationByIdError,
    };
};

export const getLocationById = (id: string | undefined | null) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getLocationByIdRequest());
        return axios
            .get(`/locations/${id}`)
            .then((response) => dispatch(getLocationByIdSuccess(response.data)))
            .catch((error) => dispatch(getLocationByIdFailure(error.message)));
    };
};

export const getLocationPublicDetailsById = (id: string) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getLocationDetailsByIdRequest());
        return axios
            .get(`/locations/shortDetails/${id}`)
            .then((response) => {
                if (response?.data?.statusCode === 200) {
                    dispatch(getLocationDetailsByIdSuccess(response.data));
                } else {
                    dispatch(getLocationDetailsByIdFailure(response?.data));
                }
            })
            .catch((error) => dispatch(getLocationDetailsByIdFailure(error.message)));
    };
};

export const locationClickEvent = (id: string, click_type: string) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(locationClickEventRequest());
        return axios
            .patch(`/locations/click-event-count?locationId=${id}&click_type=${click_type}`)
            .then((response) => dispatch(locationClickEventSuccess(response.data)))
            .catch((error) => dispatch(locationClickEventFailure(error.message)));
    };
};

// Location Filters Action Creators
const getLocationFiltersRequest = () => {
    return {
        type: GET_LOCATION_FILTERS_REQUEST,
    };
};

const getLocationFiltersSuccess = (filtersData: AnyIfEmpty<object>) => {
    return {
        type: GET_LOCATION_FILTERS_SUCCESS,
        payload: filtersData,
    };
};

const getLocationFiltersFailure = (filtersError: string) => {
    return {
        type: GET_LOCATION_FILTERS_FAILURE,
        payload: filtersError,
    };
};

export const resetLocationFilters = () => {
    return {
        type: RESET_LOCATION_FILTERS,
    };
};

// Get Location Filters Dispatch
export const getLocationFilters = (locationId: string | undefined | null) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        if (!locationId) {
            dispatch(getLocationFiltersFailure('Location ID is required'));
            return;
        }

        dispatch(getLocationFiltersRequest());
        return axios
            .get(`/locations/filters/${locationId}`)
            .then((response) => {
                if (response?.data?.statusCode === 200) {
                    dispatch(getLocationFiltersSuccess(response.data?.filters));
                } else {
                    dispatch(getLocationFiltersFailure(response?.data?.message || 'Failed to fetch location filters'));
                }
            })
            .catch((error) => {
                dispatch(getLocationFiltersFailure(error?.response?.data?.message || error.message || 'An error occurred while fetching location filters'));
            });
    };
};
